import { get, post } from './axios';
import type {
  IGetApiStudentMasterTrailLinkResponse,
  IGetApiStudentMasterV2AppPageSubjectChineseKeySubjectExtensionPageResponse,
  IGetApiStudentMasterV2AppPageSubjectMathKeySubjectExtensionPageResponse,
  IGetApiStudentMasterV2AppPageSubjectEnglishKeySubjectExtensionPageResponse,
  IGetApiStudentMasterV2AppPageSubjectChineseKeyChineseReadingClubRequest,
  IGetApiStudentMasterV2AppPageSubjectChineseKeyChineseReadingClubResponse,
} from './interface/common';

export type PickResContent<T extends { content?: unknown }> = Readonly<
  NonNullable<T['content']>
> & {
  // _original: AxiosResponse<IGeneralResponse>;
};
export interface DeviceDetectionRes {
  studentCode: string;
  platform: string;
  data: {
    deviceDetection: boolean;
    courseReportList: string[];
    [key: string]: unknown;
  };
}
export interface ContentData<T> {
  content: T;
}

// 上报用户设置检测结果 仅在成功的时候才上报
export const createDeviceDetect = (data: Record<string, unknown>) => {
  return post(
    `${process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN}/ms-user/api/user/device/create`,
    data,
  );
};

// 获取用户设备检测结果列表
export const getDeviceDetect = (data: { studentCode: string }) => {
  return post<DeviceDetectionRes[], DeviceDetectionRes[]>(
    `${process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN}/ms-user/api/user/device/list`,
    data,
  );
};

// 更新版本状态
export const updateVersionState = (data: Record<string, unknown>) => {
  return post<unknown, unknown>(`/api/student/web/event/update`, data);
};

/**
 * 获取中文拓科二级页信息
 * @param params 请求参数，包含subject和key
 * @returns 中文拓科二级页信息
 */
export const getChineseSubjectExtensionPage = () => {
  return get<
    IGetApiStudentMasterV2AppPageSubjectChineseKeySubjectExtensionPageResponse,
    IGetApiStudentMasterV2AppPageSubjectChineseKeySubjectExtensionPageResponse
  >('api/student/master/v2/app_page?subject=CHINESE&key=SubjectExtensionPage');
};

/**
 * 获取数学拓科二级页信息
 * @param params 请求参数，包含subject和key
 * @returns 数学拓科二级页信息
 */
export const getMathSubjectExtensionPage = () => {
  return get<
    IGetApiStudentMasterV2AppPageSubjectMathKeySubjectExtensionPageResponse,
    IGetApiStudentMasterV2AppPageSubjectMathKeySubjectExtensionPageResponse
  >('api/student/master/v2/app_page?subject=MATH&key=SubjectExtensionPage');
};

/**
 * 获取英文拓科二级页信息
 * @param params 请求参数，包含subject和key
 * @returns 英文拓科二级页信息
 */
export const getEnglishSubjectExtensionPage = () => {
  return get<
    IGetApiStudentMasterV2AppPageSubjectEnglishKeySubjectExtensionPageResponse,
    IGetApiStudentMasterV2AppPageSubjectEnglishKeySubjectExtensionPageResponse
  >('api/student/master/v2/app_page?subject=ENGLISH&key=SubjectExtensionPage');
};

/**
 * 获取中文云上故事屋专题页信息
 * @param params 请求参数，包含subject和key
 * @returns 中文云上故事屋专题页信息
 */
export const getChineseReadingClubPage = (
  params: IGetApiStudentMasterV2AppPageSubjectChineseKeyChineseReadingClubRequest,
) => {
  return get<
    IGetApiStudentMasterV2AppPageSubjectChineseKeyChineseReadingClubResponse,
    IGetApiStudentMasterV2AppPageSubjectChineseKeyChineseReadingClubResponse
  >('api/student/master/v2/app_page', { params });
};

/**
 * 获取试听落地页链接
 */
export const getTrailLink = () => {
  return get<
    IGetApiStudentMasterTrailLinkResponse,
    IGetApiStudentMasterTrailLinkResponse
  >('/api/student/master/trail_link');
};
